import { useEffect, useState } from "react";
import { toast } from "sonner";
import {
  VentureCard,
  VentureCardContent,
  VentureCardHeader,
  VentureCardTitle,
} from "@/components/ui/venture-card";
import { Button } from "@/components/ui/button";
import { InputVenture } from "@/components/ui/input-venture";
import { supabase } from "@/integrations/supabase/client";

export default function Settings() {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    supabase.auth.getUser().then(({ data }) => {
      if (data?.user?.email) setEmail(data.user.email);
    });
  }, []);

  async function handleChangePassword() {
    if (!password || password.length < 8) {
      toast.error("Password must be at least 8 characters.");
      return;
    }
    setLoading(true);
    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      toast.success("Password updated.");
      setPassword("");
    } catch (err: unknown) {
      toast.error(err instanceof Error ? err.message : "Failed to update password");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Settings</h1>
        <p className="text-muted-foreground">Manage your account.</p>
      </div>

      <VentureCard>
        <VentureCardHeader>
          <VentureCardTitle>Account</VentureCardTitle>
        </VentureCardHeader>
        <VentureCardContent className="space-y-4">
          <div>
            <label className="text-sm text-muted-foreground">Email</label>
            <p className="font-medium">{email || "…"}</p>
          </div>
          <div className="space-y-2">
            <label className="text-sm text-muted-foreground">New password</label>
            <InputVenture
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="At least 8 characters"
            />
            <Button onClick={handleChangePassword} disabled={loading || !password}>
              {loading ? "Updating…" : "Change Password"}
            </Button>
          </div>
          <p className="text-xs text-muted-foreground">
            Account settings coming soon — more options will appear here.
          </p>
        </VentureCardContent>
      </VentureCard>
    </div>
  );
}
